export default __webpack_public_path__ + "static/media/or_4.cd40c69b.mp3";